import { render, staticRenderFns } from "./bonus_page.vue?vue&type=template&id=6e99bfae&scoped=true"
import script from "./bonus_page.vue?vue&type=script&lang=js"
export * from "./bonus_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e99bfae",
  null
  
)

export default component.exports